import { useEffect, useState } from 'react';

/**
 * A clock that ticks the component.
 *
 * The only thing left that changes with time is how old the pet is, so this
 * replaces the old one-second prediction loop: a readout in minutes does not
 * need redrawing more than twice a minute.
 */
export function useNow(intervalMs: number): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(timer);
  }, [intervalMs]);

  return now;
}
